<style src='@/resources/styles/wall.css' scoped></style>

<template>
  <main>
    <div class='inner cover'>
      <h1 class='lead'>Wall of Love ❤️</h1>

      <div class='center'>
        <img src="@/resources/images/wall/p2.jpg" title="If only we knew which name that was.."/>
      </div>

      <div class='center'>
          <img src="@/resources/images/wall/p1.jpg" title="We're in awe of how awe-mazing this awesome comment is" />
      </div>

      <div class='center'>
        <img src="@/resources/images/wall/ih1.png" title="Muchas gracias!"/>
      </div>

      <div class='center'>
        <img src="@/resources/images/wall/ih2.png" title="How indeed." />
      </div>

      <div class='center'>
        <img src="@/resources/images/wall/slack1.png" title="With blood, sweat, and tears. But mostly tears." />
      </div>

      <div class='center'>
        <img src="@/resources/images/wall/obama.gif" title="By 'I' we mean 'We', of course" />
      </div>

      <div class='center'>
        Love Naminus and want your comment featured here? Please drop us a <a href="mailto:hi@naminus.com">line</a>
        or <a href="https://twitter.com/AliAkhtar_" target="_blank">tweet</a>.
      </div>


    </div>
  </main>
</template>

<script>
  import {mapActions} from "vuex";

  export default {
    name: 'WallOfLoveView',

    mounted() {
      this.pageLoaded(this.$route);
    },

    methods:  {
      ...mapActions(['pageLoaded'])
    }
  }
</script>
